export enum UserMode {
    Pro = "exchange",
    Lightning = "otc"
}

export interface UserModeAPI {
    mode: UserMode
}
